import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useWorkOrderStats from "../../data/useWorkOrderStats";

export default function WorkOrderStats() {
  const { t } = useTranslation("workOrders");
  const workOrderStats = useWorkOrderStats();

  const [total     , setTotal     ] = useState(0);
  const [toDo      , setToDo      ] = useState(0);
  const [inProgress, setInProgress] = useState(0);
  const [completed , setCompleted ] = useState(0);

  useEffect(() => {
    if (workOrderStats.data?.data) {
      setTotal(workOrderStats.data.data.total);
      setToDo(workOrderStats.data.data.toDo);
      setInProgress(workOrderStats.data.data.inProgress);
      setCompleted(workOrderStats.data.data.complete);
    }
  }, [workOrderStats.data]);


  return (
    <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <StatCard title={t("Total")} value={total} />
      <StatCard title={t("To Do")} value={toDo} />
      <StatCard title={t("In Progress")} value={inProgress} />
      <StatCard title={t("Completed")} value={completed} />
    </div>
  );
}

interface StatCardProps {
  title: string;
  value: number;
}

function StatCard({ title, value }: StatCardProps) {
  return (
    <div className="bg-white shadow rounded-lg px-4 py-3">
      <p className="text-xs font-medium text-gray-500">{title}</p>
      <p className="mt-1 text-2xl font-semibold text-gray-900">{value}</p>
    </div>
  );
}
